import { Box, FormLabel, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppSettings } from '../../settings/appSettingsSlice';
import { fetchSiomSettings } from '../../settings/siomSettingsSlice';
import { fetchStudentSettings } from '../../settings/studentSettingsSlice';
import useSearchDebounce from '../../subcomponents/SearchDebounce';
import { setAlertMessage, setAlertSeverity, setAlertStatus } from '../../subcomponents/alertSlice';
import { fetchExternalConnectionSettings, putSetting, resetUpdateStatus, setChangedThemeSettings } from '../adminSlice';

export default function AdminSettingNumber({ settingsType, settingKey, settingDefaultValue, formLabel, formText, xsSize, minValue, MaxValue, stepValue, notEmpty, disabledCondition, departmentSetting }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { updateSetting } = useSelector((state) => state.admin);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { activeDepartment } = useSelector((state) => state.settings.theme);

    const [settingChanged, setSettingChanged] = useState(false);
    const [settingValue, setSettingValue] = useSearchDebounce();

    // Put Callback
    useEffect(() => {
        if (updateSetting.status === "success") {
            // Alert
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${resourceFinal[appLanguage].admin.SETTING_CHANGED_SUCCESS}`));
            dispatch(setAlertSeverity("success"));

            // Reset status & values
            dispatch(resetUpdateStatus());
            setSettingChanged(false);
            setSettingValue(null);

            // Get new setting values
            if (settingsType === "app")
                dispatch(fetchAppSettings());

            if (settingsType === "siom")
                dispatch(fetchSiomSettings());

            if (settingsType === "student")
                dispatch(fetchStudentSettings());

            if (settingsType === "external")
                dispatch(fetchExternalConnectionSettings());

            if (settingsType === "theme")
                dispatch(setChangedThemeSettings(true));
        } else if (updateSetting.status === "failed") {
            // Alert
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${resourceFinal[appLanguage].admin.SETTING_CHANGED_FAILED}`));
            dispatch(setAlertSeverity("error"));

            // Reset status
            dispatch(resetUpdateStatus());
        };
    }, [updateSetting.status]);

    useEffect(() => {
        if (settingKey !== null && settingValue !== null && (!notEmpty || settingValue !== "")) {
            dispatch(putSetting({
                key: settingKey,
                value: settingValue,
                modifiedBy: `AP/${user?.number}`,
                departmentId: siomSettings?.useMultipleDepartments ? activeDepartment[0].id : undefined,
                departmentSpecific: departmentSetting,
            }));
        };
    }, [dispatch, user, settingChanged, settingKey, settingValue]);

    return (
        <Grid size={{ xs: xsSize }} sx={{ display: 'flex' }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: '1 1 auto',
                border: 1,
                borderColor: 'white.dark',
                borderRadius: 1,
                bgcolor: 'white.light',
                p: 1
            }}>
                <FormLabel component="legend">{formLabel}</FormLabel>
                <TextField
                    fullWidth type="number"
                    defaultValue={settingDefaultValue}
                    disabled={disabledCondition}
                    inputProps={{
                        ...(minValue && { min: minValue }),
                        ...(stepValue && { step: stepValue }),
                        ...(MaxValue && { max: MaxValue }),
                    }}
                    onChange={(e) => {
                        setSettingChanged(true);
                        setSettingValue(e.target.value);
                    }}
                    variant="standard"
                    helperText={formText}
                />
            </Box>
        </Grid>
    );
}
